import React from 'react'
import PropTypes from 'prop-types';
import EvaluationFinish from "./EvaluationFinish";

function Index(
    {
        expanded,
    }) {

    return (expanded && <EvaluationFinish />)
}

Index.propTypes = {
    classes: PropTypes.any,
}

export default Index;